export const PATTERNS = {
  EMAIL: /^(\w+[\w-+\\.]*)@(\w+([-\\.]\w+)*\.[a-zA-Z]{2,})$/,
  PASSWORD: /^.{7,}$/,
  ACCESS_ID: /^\S+$/,
};

export const FormValidator = (
  types: string[],
  value: any,
  fieldName: string,
  invalidError?: string
) => {
  let errorMsg = '';
  const noOfTypes = types.length;

  for (let index = 0; index < noOfTypes; index++) {
    const type = types[index];
    const validation = PATTERNS[type as keyof typeof PATTERNS];

    switch (type) {
      case 'REQUIRED':
        if (!value || value.length === 0) {
          errorMsg = `${fieldName} is required`;
        }
        break;

      case 'EMAIL':
      case 'PASSWORD':
      case 'ACCESS_ID':
        if (value && validation && !validation.test(value)) {
          errorMsg = invalidError as string;
        }
        break;

      default:
        break;
    }
    if (errorMsg) {
      return errorMsg;
    }
  }
  return errorMsg;
};
